<template>
    <v-container class="d-flex flex-column text-body-2 font-weight-light" :class="smAndDown ? 'py-0 pb-16' : 'pt-16 '">
        <div style="height: 50vh"></div>
        <div class="d-flex w-100">
            <v-spacer />
            <v-row class="w-50" :class="smAndDown ? '' : 'text-end'">
                <v-spacer />
                <v-col :cols="smAndDown ? 4 : 3" class="d-flex flex-column text-start">
                    <div class="font-weight-medium pb-4">About</div>
                    <router-link class="mb-4" to="/" :class="$route.path !== '/' ? '' : 'text-blue-darken-4'">Home</router-link>
                </v-col>
                <v-col :cols="smAndDown ? 4 : 3" class="d-flex flex-column">
                    <div class="font-weight-medium pb-4">Legal</div>
                    <a class="mb-4" href="https://june07.com/terms">Terms</a>
                    <a href="https://june07.com/privacy">Privacy</a>
                </v-col>
            </v-row>
        </div>
        <v-divider class="my-4" thickness="2" />
        <div class="d-flex text-grey" :class="smAndDown ? 'text-caption text-no-wrap flex-column' : ''">© 2025 June07
            <v-spacer />
            <div class="font-italic font-weight-light">Happy Graduation to You!</div>
        </div>
    </v-container>
</template>
<style scoped>
a {
    text-decoration: none;
    color: inherit;
}
</style>
<script setup>
import { useDisplay } from 'vuetify/lib/framework.mjs'

const { smAndDown } = useDisplay()
</script>
